<div [class]="controlCssClass ? controlCssClass : 'form-group'">
  @if (showSkip) {
    <div class="question-skip">
      <label class="selection">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <div class="selection__inner">
            <div class="selection__main">
              <div class="selection__left">
                <div class="selection__switch"></div>
              </div>
              <div class="selection__content">
                <div class="selection__label">
                  <div class="selection__title">Skip for now</div>
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    }
    @if (showLabel && (labelText || question?.question_copy || question?.email_version)) {
      <label class="form-group__label" [for]="uniqueControlId">
        {{question?.question_copy || question?.email_version || labelText}}
      </label>
    }
    @if (readOnly) {
      <input type="text" disabled="" [value]="question?.answer" placeholder="Placeholder" class="form-control">
    }
    @if (!readOnly) {
      <div class="input-wrap" [ngClass]="{ 'ui-front': useUiFront }">
        <select [name]="uniqueControlName" [id]="uniqueControlId" class="ui-selectmenu">
          <option value="">{{(showOptionLabel && labelText) ? (labelText | titlecase) : 'Select Option'}}</option>
          @for (option of options; track option) {
            <option [value]="getValue(option)" [disabled]="option?.disabled" [selected]="getSelectedOption(option)">{{getOptionText(option)}}</option>
          }
        </select>
      </div>
    }
  </div>
